import React from 'react';

const BellIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.857 17.082a23.848 23.848 0 0 1-5.714 0A2.4 2.4 0 0 0 6 19.5c0 .83.448 1.5 1 1.5h10c.552 0 1-.67 1-1.5a2.4 2.4 0 0 0-2.143-2.418ZM4.5 8.25a7.5 7.5 0 0 1 15 0c0 2.708.63 4.698 1.237 5.94.233.48-.096 1.06-.633 1.06H3.896c-.537 0-.866-.58-.633-1.06C3.87 12.948 4.5 10.958 4.5 8.25Z"
    />
  </svg>
);

export default BellIcon;
